const customIcons = {
  'angle-down': '\\f107',
  'angle-left': '\\f104',
  'angle-right': '\\f105',
  'angle-up': '\\f106',
  article: '\\e900',
  'article-blog-post': '\\e900',
  asterisk: '\\f069',
  bold: '\\f032',
  bolt: '\\f0e7',
  book: '\\f02d',
  calendar: '\\f073',
  'c-logo': '\\e909',
  'c-chess': '\\e90f',
  'c-money': '\\e911',
  'c-question': '\\e912',
  'case-study': '\\e901',
  'check-square': '\\f046',
  checkmark: '\\f00c',
  'clear-formatting': '\\e90e',
  clock: '\\f017',
  'cloud-download': '\\f0ed',
  code: '\\f121',
  comment: '\\f075',
  'comment-o': '\\f0e5',
  comments: '\\f086',
  compress: '\\f066',
  close: '\\f00d',
  copy: '\\e90c',
  dollar: '\\f155',
  ebook: '\\e902',
  'ellipsis-v': '\\f142',
  email: '\\e903',
  event: '\\f133',
  'external-link': '\\f08e',
  expand: '\\f065',
  facebook: '\\f09a',
  file: '\\f15b',
  'file-pdf': '\\f1c1',
  'file-text': '\\f0f6',
  film: '\\f008',
  filter: '\\f0b0',
  font: '\\f031',
  gear: '\\e910',
  gears: '\\f085',
  'google-plus': '\\f0d5',
  group: '\\f0c0',
  image: '\\f03e',
  'info-circle': '\\f05a',
  infographic: '\\e904',
  instagram: '\\e90b',
  invalid: '\\f05e',
  italic: '\\f033',
  justify: '\\f039',
  lightbulb: '\\f0eb',
  link: '\\f0c1',
  'linked-in': '\\f0e1',
  list: '\\f0ca',
  'list-ol': '\\f0cb',
  lock: '\\f023',
  magic: '\\f0d0',
  'mail-reply': '\\f112',
  'map-marker': '\\f041',
  medkit: '\\f0fa',
  messages: '\\f0e0',
  minus: '\\f068',
  move: '\\f047',
  music: '\\f001',
  'original-research': '\\e906',
  other: '\\e905',
  paperclip: '\\f0c6',
  pencil: '\\f040',
  photo: '\\f030',
  pillar: '\\e90a',
  plug: '\\f1e6',
  plus: '\\f067',
  podcast: '\\e90d',
  presentation: '\\f108',
  'question-circle': '\\f059',
  quote: '\\e977',
  refresh: '\\f021',
  reply: '\\f112',
  rocket: '\\f135',
  search: '\\f002',
  spinner: '\\f110',
  'star-empty': '\\f006',
  'star-fill': '\\f005',
  strikethrough: '\\f0cc',
  subscript: '\\f12c',
  superscript: '\\f12b',
  table: '\\f0ce',
  tags: '\\f02c',
  'thumbs-down': '\\f088',
  'thumbs-right': '\\f0a4',
  'thumbs-up': '\\f087',
  tiles: '\\f009',
  'times-circle': '\\f057',
  'touch-nav': '\\f039',
  trash: '\\e9ac',
  tumblr: '\f173',
  twitter: '\\f099',
  unassigned: '\\f128',
  underline: '\\f0cd',
  unlink: '\\e913',
  unlock: '\\f13e',
  upload: '\\f093',
  user: '\\f007',
  video: '\\e907',
  warning: '\\f071',
  whitepaper: '\\e908',
  x: '\\f00d',
  'youtube-play': '\\f16a',
};

export default customIcons;
